module.exports = __webpack_public_path__ + "img/banner.8a163725.jpeg";